import React from "react";
import pinIcon from "../assets/images/Pin.png";
import innerBanner from "../assets/images/inner-banner.png";
import { NavLink } from "react-router-dom";

function Contact() {
  return (
    <>
      {/* Inner Banner */}
      <section id="inner-banner-wrapper">
        <div className="banner-image">
          <img className="w-100" src={innerBanner} alt="Contact Banner" />
        </div>
        <div className="breadcrumb">
          <h2>Contact</h2>
          <ul>
            <li>
              <NavLink to="/">Home &gt; </NavLink>
            </li>
            <li>Contact</li>
          </ul>
        </div>
      </section>

      {/* Contact Section */}
      <div id="cart-wrapper">
        <div className="container">
          <div className="contact-container">
            <div className="contact-box w-100 mb-5 text-start ps-5">
                <h3 className="mb-4 text-start">Contact</h3>
            <h4>
              <span className="c-img"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
</svg></span>
<span>Phone: </span> 
<a href="#"> +31 (85) 0130270</a></h4>
            <h5> <span className="c-img"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
  <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
</svg></span>
            <span>General Enquiries: </span><a href="mailto:info@actu-all.com"> info@actu-all.com</a></h5>
            <h5> <span className="c-img"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
  <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"/>
</svg></span>
              <san>Sales Enquiries: </san><a href="mailto:sales@actu-all.com"> sales@actu-all.com</a></h5>
            </div>
            <h3>Production / Warehouse</h3>
            <div className="contact-box-wrapper">
            <div className="contact-box">
                <div className="icon">
                  <img src={pinIcon} alt="Location" />
                </div>
                <div className="contact-info">
                    <p>Actu-All Chemicals B.V <br/>Randmeer 36 <br/>
                        5347 JW, Oss 
                    </p>
                </div>
            </div>
            <div className="contact-box">
                <div className="icon">
                  <img src={pinIcon} alt="Location" />
                </div>
                <div className="contact-info">
                    <p>Actu-All Chemicals B.V <br/> Buitenvaart 1019<br/>
                        7905 SB Hoogeveen 
                    </p>
                </div>
            </div>
           
           
            </div>
            <h3>Partner Location</h3>
            <div className="contact-box-wrapper">
            <div className="contact-box">
               <div className="icon">
                  <img src={pinIcon} alt="Location" />
                </div>
                <div className="contact-info">
                    <p>Brunschwig Chemie  <br/>Hexaanweg 2, <br/>
                      1041 AX Amsterdam
                    </p>
                </div>
            </div>
            <div className="contact-box">
               <div className="icon">
                  <img src={pinIcon} alt="Location" />
                </div>
                <div className="contact-info">
                    <p>InstruLabo B.V. <br/> Spuiweg 22 j -<br/>
                      5145 NE  Waalwijk
                    </p>
                </div>
            </div>
            

           
            </div>
            <h3>Third Party logistics </h3>
            <div className="contact-box-wrapper">
            <div className="contact-box">
                <div className="icon">
                  <img src={pinIcon} alt="Location" />
                </div>
                <div className="contact-info">
                    <p>B Ter Riele Transporten  <br/> Withagenweg 40, <br/>
                      7384 SB Wilp
                    </p>
                </div>
            </div>
            <div className="contact-box">
               <div className="icon">
                  <img src={pinIcon} alt="Location" />
                </div>
                <div className="contact-info">
                    <p>Imperial Chemical Logistics <br/> Ekkersrijt 7604, <br/>
                      5692 HP Son
                    </p>
                </div>
            </div>
           

           
            </div>
        
      
       
        
        </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
